import classNames from "classnames/bind";
import styles from "./Panel.module.scss";

const cx = classNames.bind(styles);

export const SIZES = ["small", "blog"] as const;

interface PanelProps {
  children?: React.ReactNode;
  size?: (typeof SIZES)[number];
}

const Panel = ({ children, size }: PanelProps) => (
  <div className={cx("panel", size)}>{children}</div>
);

export default Panel;
